// Copyright 2025, Imprivata, Inc.  All rights reserved.

import { Button, Modal, Input } from '@imprivata-cloud/components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './IdentityUsersEmpty.less';

const TRANSLATION_ROOT = 'portal.settings.identity-users';

const IdentityUsersEmpty = () => {
  const { t } = useTranslation();
  const [identityProviderModalOpen, setIdentityProviderModalOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const seeInstructions = () => {
    window.open('https://www.imprivata.com', '_blank', 'noopener');
  };

  const handleCancel = () => {
    setInputValue('');
    setIdentityProviderModalOpen(false);
  };

  const handleOk = () => {
    console.log('Input value:', inputValue);
    setInputValue('');
    setIdentityProviderModalOpen(false);
  };

  return (
    <>
      <div className="identity-empty">
        {t('common.no-users')}
        <Button type={'link'} onClick={() => setIdentityProviderModalOpen(true)}>
          {t(`${TRANSLATION_ROOT}.add-identity-user`)}
        </Button>
      </div>

      <Modal
        open={identityProviderModalOpen}
        title={t(`${TRANSLATION_ROOT}.modal.title`)}
        width={610}
        onOk={handleOk}
        okText={t('save')}
        okButtonProps={{ disabled: inputValue.trim() === '' }}
        onCancel={handleCancel}
        maskClosable={false}
      >
        <div className="identity-modal">
          <div className="identity-modal-instructions">
            <Button type={'link'} onClick={seeInstructions} style={{ padding: 0, textDecoration: 'none' }}>
              {t(`${TRANSLATION_ROOT}.modal.instructions`)}
            </Button>
          </div>

          {t(`${TRANSLATION_ROOT}.modal.domain`)}
          <div className="identity-modal-id">
            <Input type="text" size="middle" value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
            <p>{t(`${TRANSLATION_ROOT}.modal.imprivata-id`)}</p>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default IdentityUsersEmpty;
